import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ContactDataResponse {
  estado: string;
  mensaje: string;
  datos: {
    nombre: string;
    telefono: string;
    correo: string;
  };
}

export interface ValidarCodigoResponse {
  estado: string;
  mensaje: string;
  datos: {
    codigoValido: boolean;
    redirectUrl?: string;
    intentosRestantes: number;
  };
}

@Injectable({
  providedIn: 'root',
})
export class VerificaContactoService {
  private readonly http = inject(HttpClient);

  /**
   * Obtiene los datos de contacto desde el servidor
   * El interceptor automáticamente agregará el header x-transaccion-token
   */
  public $getContactData(): Observable<ContactDataResponse> {
    return this.http
      .get<ContactDataResponse>(`${environment.baseUrl}/datos-contacto`);
  }

  public getContactData(): Promise<ContactDataResponse> {
    return firstValueFrom(this.http
      .get<ContactDataResponse>(`${environment.baseUrl}/datos-contacto`));
  }

  /**
   * Valida el código OTP enviado por el usuario
   * El interceptor automáticamente agregará el header x-transaccion-token
   */
  public validarCodigo(codigo: string): Observable<ValidarCodigoResponse> {
    return this.http.post<ValidarCodigoResponse>(
      `${environment.baseUrl}/validar-codigo`,
      {
        codigo,
      });
  }
}
